<script>
import { mapActions } from "vuex";

export default {
  title: "Criar telefone",
  props: {
    account: {
      type: Object,
      required: true
    },
    dialog: {
      Type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapActions("phones", ["createPhone"]),
    ...mapActions("snackbar", ["snackbarSuccess"]),

    async createNewPhone() {
      this.loader = true;

      try {
        await this.createPhone({
          data: {
            country_code: this.countryCode,
            area_code: this.areaCode,
            number: this.number
          },
          accountId: this.account.id
        });
        this.snackbarSuccess("Telefone criado com sucesso");
      } catch (e) {
        this.$toast.error("Nao foi possivel criar o telefone!");
      }

      this.loader = false;
      this.emitClose();
      this.emitRefresh();
    },
    emitRefresh() {
      this.$emit("refresh");
    },
    emitClose() {
      this.clearData();
      this.$emit("close");
    },
    clearData() {
      this.number = "";
      this.areaCode = "";
      this.countryCode = "55";
    }
  },
  data() {
    return {
      loader: false,
      number: "",
      areaCode: "",
      countryCode: "55"
    };
  }
};
</script>

<template>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="emitClose()">
    <v-card>
      <v-card-title>
        <span class="headline">Criar telefone</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="countryCode"
                label="DDI (Codigo do Pais)"
                v-mask="'##'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="areaCode"
                label="DDD (Codigo de area)"
                v-mask="'##'"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="number"
                label="Telefone"
                v-mask="'#########'"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="emitClose()">
          Cancelar
        </v-btn>
        <v-btn color="primary" text @click="createNewPhone()" :loading="loader">
          Criar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Account/Phones/Create.vue